import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcFinanceBreakdownTitleClasses,
} from '@dxp-module/themes'

const financeBreakdownTitleStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcFinanceBreakdownTitleClasses
>(
  ({ palette }) => ({
    mainTitle: {
      paddingBottom: 12,
      color: palette.primary.main,
      textAlign: 'center',
    },
    mainTitleContent: {},
  }),
  { name: 'FC_FinanceBreakdownTitle' }
)

export default financeBreakdownTitleStyles
